import React, { useState,useContext } from "react";
import { Button, Modal } from "react-bootstrap";

import {Context} from "../../../_context/Store";
import SherbortLogo from "../../../styles/img/sherbot-logo.png";

export const UiModal = (props) => {
    return (
        <>
            <Modal
                show={props.show}
                onHide={props.modalShowHide}
                className={props.className ? props.className : "sb-main-modal sb-sign-up-modal" } 
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{props.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiShopModal = (props) => {
    return (
        <>
            <Modal
                show={props.show}
                onHide={props.modalShowHide}
                backdrop={props.backdrop}
                className="sb-modal-order"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{props.children}</Modal.Body>
            </Modal>
        </>
    );
};


export const UiWalletModal = (props) => {
    return (
        <>
            <Modal
                show={props.show}
                onHide={props.modalShowHide}
                backdrop={props.backdrop}
                className="sb-modal-wallet"
                id={props.id}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}
                    <h5>{props.points}</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>{props.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiSpinWinCarouselModal = (props) => {
    return (
        <>
            <Modal
                show={props.show}
                onHide={props.modalShowHide}
                backdrop={props.backdrop}
                className="sb-modal-spin-win"
                id={props.id}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                    
                </Modal.Header>
                <Modal.Body>{props.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiLargeModal = (props) => {

    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
         dispatch({
              type: 'LARGE_MODAL',
              payload: { show: false },
         });
    };

    return (
        <>
            <Modal
                show={state.ui_large_modal.show}
                onHide={handleClose}
                className="sb-main-modal sb-large-modal "
            >
                <Modal.Header closeButton>
                    <Modal.Title>{state.ui_large_modal.title}</Modal.Title>
                </Modal.Header>
                {state.ui_large_modal.subTitle &&  <div className="sb-large-modal__sub-title">{state.ui_large_modal.subTitle}</div>}
                <Modal.Body>{state.ui_large_modal.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiChatBotModal = (props) => {

    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
         dispatch({
              type: 'CHAT_BOX_MODAL',
              payload: { show: false },
         });
    };

    return (
        <>
            <Modal
                show={state.ui_chat_box.show}
                onHide={handleClose}
                backdrop="static"
                centered
                className="sb-main-modal sb-chat-box-modal "
            >
                <Modal.Header closeButton>
                   <img src={SherbortLogo}/>
                </Modal.Header>
                
                <Modal.Body>{state.ui_chat_box.children}</Modal.Body>
            </Modal>
        </>
    );
}

export const UiFooterContentModal = (props) => {

    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
         dispatch({
              type: 'FOOTER_CONTENT_MODAL',
              payload: { show: false },
         });
    };

    return (
        <>
            <Modal
                show={state.ui_footer_modal.show}
                onHide={handleClose}
                centered
                className="sb-footer-support-modal "
            >
                <Modal.Header closeButton>
                  
                </Modal.Header>
                
                <Modal.Body>{state.ui_footer_modal.children}</Modal.Body>
            </Modal>
        </>
    );
}

export const UiPdfModal = (props) => {
    return (
        <>
            <Modal
                show={props.show}
                onHide={props.modalShowHide}
                backdrop={props.backdrop}
                className="sb-modal-pdf-view"
                id={props.id}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{props.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiHomePerformanceModal = (props) => {
   
    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
        localStorage.setItem('perfomance-view','true');  
         dispatch({
              type: 'HOME_PERFORMANCE_MODAL',
              payload: { show: false },
         });
    };

    return (
        <>
            <Modal
                show={state.ui_home_performance_modal.show}
                onHide={handleClose}
                backdrop="static"
                centered
                className="sb-performance-modal"
               
            >
                <Modal.Header closeButton>
                    <Modal.Title>{state.ui_home_performance_modal.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{state.ui_home_performance_modal.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiVotingModal = (props) => {
   
    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
         dispatch({
              type: 'VOTING_MODAL',
              payload: { show: false },
         });
       
    };

    return (
        <>
            <Modal
                show={state.ui_voting_modal.show}
                onHide={handleClose}
                backdrop="static"
               
                className="sb-voting-modal"
               
            >
                <Modal.Header closeButton>
                    <Modal.Title>{state.ui_voting_modal.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{state.ui_voting_modal.children}</Modal.Body>
            </Modal>
        </>
    );
};